import { colors, fonts } from 'theme'
import css from 'styled-jsx/css'

export const prefix = className => `appointment-cancellation-${className}`

export const classNames = {
  container: 'cancellation-form',
  header: prefix('header'),
  title: 'title',
  description: 'description',
  buttons: prefix('buttons')
}

export default css`
  .${classNames.container} {
    min-width: 580px;
    min-height: 363px;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }
  
  .${classNames.container} :global(.${classNames.header}) {
    display: flex;
    flex-direction: column;
  }
  
  .${classNames.container} :global(.${classNames.buttons}) {
    margin: 10px auto;
  }
  
  .${classNames.title}, .${classNames.description} {
    text-align: center;
    margin: 5px;
    font: ${fonts.bold};
    font-size: 24px;
    color: ${colors.secondary}
  }
  .${classNames.description} {
    font: ${fonts.medium};
    margin-bottom: 30px;
    font-size: 24px;    
  }
`
